import { useMemo } from 'react';
import { StyleSheet } from 'react-native';
import { useScale } from '../../hooks/useScale';
import { useColors } from '../../hooks/useColors';
import theme from '../../common/theme';

const AppearanceSettingsStyles = () => {
  const { scale } = useScale();
  const { colors } = useColors();

  return useMemo(
    () =>
      StyleSheet.create({
        card: {
          backgroundColor: colors.elevation1,
          borderRadius: theme.radius.l,
          padding: scale(16),
        },
        tilesRow: {
          flexDirection: 'row',
          columnGap: scale(12),
        },
        tile: {
          flex: 1,
          alignItems: 'center',
          justifyContent: 'center',
          rowGap: scale(4),
          paddingVertical: scale(20),
          borderRadius: theme.radius.m,
          borderWidth: 1,
          borderColor: colors.borderColor,
          backgroundColor: colors.elevation0,
          userSelect: 'none',
        },
        tileSelected: {
          borderColor: colors.positive,
          backgroundColor: colors.elevation2,
        },
        tileGlyph: {
          color: colors.text,
          fontFamily: theme.fonts.semibold,
        },
        tileGlyphSMALL: {
          fontSize: scale(22),
        },
        tileGlyphMEDIUM: {
          fontSize: scale(28),
        },
        tileGlyphLARGE: {
          fontSize: scale(34),
        },
        tileLabel: {
          color: colors.textLight,
          fontSize: scale(13),
          fontFamily: theme.fonts.regular,
        },
        tileLabelSelected: {
          color: colors.text,
        },
        divider: {
          height: 1,
          backgroundColor: colors.borderColor,
          marginVertical: scale(16),
        },
        previewLabel: {
          color: colors.textLight,
          fontSize: scale(12),
          letterSpacing: scale(1),
          textTransform: 'uppercase',
          fontFamily: theme.fonts.medium,
          marginBottom: scale(10),
        },
        previewDocket: {
          backgroundColor: colors.elevation2,
          borderRadius: theme.radius.m,
          padding: scale(14),
          rowGap: scale(6),
        },
        previewHeaderRow: {
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-between',
        },
        previewMeta: {
          color: colors.textLight,
          fontSize: scale(13),
          fontFamily: theme.fonts.regular,
        },
        previewItemName: {
          color: colors.text,
          fontSize: scale(18),
          fontFamily: theme.fonts.semibold,
        },
        previewModifiers: {
          color: colors.textLight,
          fontSize: scale(14),
          fontFamily: theme.fonts.regular,
        },
        themeCard: {
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-between',
          backgroundColor: colors.elevation1,
          borderRadius: theme.radius.l,
          paddingVertical: scale(16),
          paddingHorizontal: scale(18),
        },
        themeTextGroup: {
          flex: 1,
          rowGap: scale(4),
        },
        themeTitle: {
          color: colors.text,
          fontSize: scale(16),
          fontFamily: theme.fonts.medium,
        },
        themeSubtitle: {
          color: colors.textLight,
          fontSize: scale(13),
          fontFamily: theme.fonts.regular,
        },
      }),
    [colors, scale],
  );
};

export default AppearanceSettingsStyles;
